const zh = {
	// 人员模块
	70105: '人员信息重复',
	70110: '人员不存在',
	// 公共
	69002: '缺少参数',
	69004: '缺少参数', //标签部分
	70405: '缺少参数', //项目
	// 69005: 'token错误',
	// 登录
	70301: '账号不存在',
	80104: '验证码不正确',
	69808: '验证码不存在',
	69806: '验证码已过期',
	69805: '验证码已经被使用过',
	70104: '用户名或密码错误',
	80108: '验证码不存在',
	80106: '验证码已过期',
	80105: '验证码已使用',
	70102: '手机号码已经被使用',
	70101: '帐号不存在',
	71009: '验证码错误',
	70111: '密码错误',
	// 分端服务器
	70202: '连接url已经存在',
	70203: '连接分端服务器异常',
	70204: '连接分端服务器异常，url错误',
	70205: '连接分端服务器异常，key错误',
	70206: '连接分端服务器异常，secret错误',
	70207: '断开连接异常',
	70201: '分端服务器ID不存在',
	70106: 'refreshToken过期',
	70107: 'refreshToken不存在',
	// 项目
	70401: '项目不存在',
	70403: '团队不存在',
	70404: '项目成员已经存在',
	// 标签
	// 70401: '标签不存在',
	// 70403: 'tag类型不正确',
	70402: 'tag名称已经被使用',
};

export default zh;
